import { Component, ViewEncapsulation, inject } from '@angular/core';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';

type Mode = 'fast' | 'quality';

@Component({
  selector: 'ai-chatbot-mode-toggle',
  templateUrl: './ai-chatbot-mode-toggle.component.html',
  styleUrl: './ai-chatbot-mode-toggle.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class AiChatbotModeToggleComponent {
  protected aiChatbotService = inject(AIChatbotService);

  protected setMode(mode: Mode): void {
    this.aiChatbotService.selectedMode.set(mode);
  }
}
